const orderBookActionTypes = {
    SET_LOADING: 'SET_LOADING',
    SET_ORDER_BOOK: 'SET_ORDER_BOOK',
}

export default orderBookActionTypes
